import React from 'react';
import { CSSTransition } from 'react-transition-group';

import css from './DrawersTransitionWrap.module.scss';

interface Props {
  visible: boolean;
  children: React.ReactNode;
}

export const DrawersTransitionWrap: React.FC<Props> = (props) => {
  const { visible, children } = props;

  return (
    <CSSTransition
      in={visible}
      timeout={parseInt(css.opentransition, 10)}
      unmountOnExit
      classNames={{
        enter: css.drawerAnimEnter,
        enterActive: css.drawerAnimEnterActive,
        exit: css.drawerAnimExit,
        exitActive: css.drawerAnimExitActive,
      }}
    >
      {children}
    </CSSTransition>
  );
};
